"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const ArtisanGoods = createSVGIcon(
  <>
    <circle cx="10" cy="11" r="7" fill="#C4AEA4" />
    <circle cx="14" cy="13" r="6.5" stroke="#312921" />
  </>,
  "Artisan goods",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Artisan goods",
    fill: "none",
    className: legacyIconCls(),
  }
);
